<template>
  <svg
    v-show="active"
    id="exfR3LTjvad1"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="exfR3LTjvad2" transform="translate(-.499995-.5)">
      <path
        clip-rule="evenodd"
        d="M10.1364,8c0-.55229.4477-1,1-1h10.7272c.5523,0,1,.44772,1,1v8.2c0,3.3137-2.6863,6-6,6h-.7272c-3.3138,0-6-2.6863-6-6v-8.2Z"
        fill="#fff"
        fill-rule="evenodd"
        stroke="#016dbf"
        stroke-miterlimit="16"
        stroke-width="2"
      />
      <path
        d="M12.8636,26h7.2728"
        fill="none"
        stroke="#016dbf"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path d="M16.5,21.25v4.75" fill="none" stroke="#016dbf" stroke-width="2" />
      <path
        clip-rule="evenodd"
        d="M22.8636,9.8999c0-.55228.4478-1,1-1h2.6364v6.2677c0,1.7851-1.4471,3.2323-3.2323,3.2323v0c-.2232,0-.4041-.1809-.4041-.404v-8.096Z"
        fill="none"
        fill-rule="evenodd"
        stroke="#016dbf"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        clip-rule="evenodd"
        d="M10.1364,9.8999c0-.55228-.44776-1-1.00005-1h-2.63636v6.2677c0,1.7851,1.44716,3.2323,3.23232,3.2323v0c.22315,0,.40409-.1809.40409-.404v-8.096Z"
        fill="none"
        fill-rule="evenodd"
        stroke="#016dbf"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        d="M16.1196,9.17082c.1197-.36852.6411-.36852.7608,0l.8769,2.69868c.0535.1648.2071.2764.3804.2764h2.8376c.3875,0,.5486.4958.2351.7236l-2.2957,1.6679c-.1402.1018-.1988.2824-.1453.4472l.8769,2.6987c.1197.3685-.3021.675-.6155.4472l-2.2957-1.6679c-.1402-.1018-.33-.1018-.4702,0l-2.2957,1.6679c-.3134.2278-.7352-.0787-.6155-.4472l.8769-2.6987c.0535-.1648-.0051-.3454-.1453-.4472l-2.2957-1.6679c-.3135-.2278-.1524-.7236.2351-.7236h2.8376c.1733,0,.3269-.1116.3804-.2764l.8769-2.69868Z"
        fill="#016dbf"
      />
    </g>
    <g id="exfR3LTjvad9" opacity="0" transform="translate(-.499995-.5)">
      <path
        clip-rule="evenodd"
        d="M10.1364,8c0-.55229.4477-1,1-1h10.7272c.5523,0,1,.44772,1,1v8.2c0,3.3137-2.6863,6-6,6h-.7272c-3.3138,0-6-2.6863-6-6v-8.2Z"
        fill="#000860"
        fill-rule="evenodd"
        stroke="#000860"
        stroke-miterlimit="16"
        stroke-width="2"
      />
      <path
        d="M12.8636,26h7.2728"
        fill="none"
        stroke="#000860"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path d="M16.5,21.25v4.75" fill="none" stroke="#000860" stroke-width="2" />
      <path
        clip-rule="evenodd"
        d="M22.8636,9.8999c0-.55228.4478-1,1-1h2.6364v6.2677c0,1.7851-1.4471,3.2323-3.2323,3.2323v0c-.2232,0-.4041-.1809-.4041-.404v-8.096Z"
        fill="none"
        fill-rule="evenodd"
        stroke="#000860"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        clip-rule="evenodd"
        d="M10.1364,9.8999c0-.55228-.44776-1-1.00005-1h-2.63636v6.2677c0,1.7851,1.44716,3.2323,3.23232,3.2323v0c.22315,0,.40409-.1809.40409-.404v-8.096Z"
        fill="none"
        fill-rule="evenodd"
        stroke="#000860"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <g id="exfR3LTjvad15_to" transform="translate(16.5,21.543006)">
        <g id="exfR3LTjvad15_ts" transform="scale(0,0)">
          <path
            d="M16.1196,9.17082c.1197-.36852.6411-.36852.7608,0l.8769,2.69868c.0535.1648.2071.2764.3804.2764h2.8376c.3875,0,.5486.4958.2351.7236l-2.2957,1.6679c-.1402.1018-.1988.2824-.1453.4472l.8769,2.6987c.1197.3685-.3021.675-.6155.4472l-2.2957-1.6679c-.1402-.1018-.33-.1018-.4702,0l-2.2957,1.6679c-.3134.2278-.7352-.0787-.6155-.4472l.8769-2.6987c.0535-.1648-.0051-.3454-.1453-.4472l-2.2957-1.6679c-.3135-.2278-.1524-.7236.2351-.7236h2.8376c.1733,0,.3269-.1116.3804-.2764l.8769-2.69868Z"
            fill="#fff"
            stroke="#fff"
            stroke-width="0"
            transform="translate(-16.5,-13.551576)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
type Props = {
  active?: boolean
}

defineProps<Props>()
</script>

<style lang="css">
/* stylelint-disable */

#exfR3LTjvad2 {
  animation: exfR3LTjvad2_c_o 800ms linear 1 normal forwards;
}
@keyframes exfR3LTjvad2_c_o {
  0% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  25% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

#exfR3LTjvad9 {
  animation: exfR3LTjvad9_c_o 800ms linear 1 normal forwards;
}
@keyframes exfR3LTjvad9_c_o {
  0% {
    opacity: 0;
  }

  12.5% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

#exfR3LTjvad15_to {
  animation: exfR3LTjvad15_to__to 800ms linear 1 normal forwards;
}
@keyframes exfR3LTjvad15_to__to {
  0% {
    transform: translate(16.5px, 21.543006px);
  }

  25% {
    transform: translate(16.5px, 21.543006px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  62.5% {
    transform: translate(16.5px, 11.857146px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  87.5% {
    transform: translate(16.5px, 13.457146px);
  }

  100% {
    transform: translate(16.5px, 13.457146px);
  }
}

#exfR3LTjvad15_ts {
  animation: exfR3LTjvad15_ts__ts 800ms linear 1 normal forwards;
}
@keyframes exfR3LTjvad15_ts__ts {
  0% {
    transform: scale(0, 0);
  }

  25% {
    transform: scale(0, 0);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  50% {
    transform: scale(1, 1);
  }

  100% {
    transform: scale(1, 1);
  }
}
</style>
